import { VIRTUAL_GRAPH_PREFIX } from 'src/common/constants/uris';

export const getGraphNameFromUri = (uri: string) =>
  uri.split(VIRTUAL_GRAPH_PREFIX)[1];
